import React, { useState } from "react";
import Papa from "papaparse";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { path_url } from "../../Config/config";

const CsvImport_vendor = ({ closeModal }) => {
  const [file, setFile] = useState(null);
  const [csvData, setCsvData] = useState([]);
  const [dbColumns] = useState([
    "firstname",
    "lastname",
    "companyname",
    "city",
    "country",
    "mobile",
    "altphone",
    "email",
    "website",
  ]);
  const [columnMapping, setColumnMapping] = useState({});
  const [mappingSaved, setMappingSaved] = useState(false); // New state to track mapping status

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile && selectedFile.type === "text/csv") {
      setFile(selectedFile);
      Papa.parse(selectedFile, {
        complete: (result) => {
          const normalizedData = result.data.map((row) => {
            let normalizedRow = {};
            Object.keys(row).forEach((key) => {
              normalizedRow[key.trim().toLowerCase()] = row[key];
            });
            return normalizedRow;
          });
          setCsvData(normalizedData);
        },
        header: true,
      });
    } else {
      toast.error("Please upload a valid CSV file.");
    }
  };

  const handleMappingChange = (selectedIndex, dbColumn) => {
    setColumnMapping({
      ...columnMapping,
      [dbColumn]: selectedIndex,
    });
  };

  const handleSubmitMapping = async () => {
    try {
      const token = localStorage.getItem("accessToken");
      const adminId = localStorage.getItem("adminId");

      const payload = {
        columnMapping,
        type: "vendor",
        usercid: adminId,
        useradmid: adminId,
      };

      const response = await axios.post(`${path_url}/import/map`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200) {
        toast.success("Mapping saved successfully! Now upload the file.");
        setMappingSaved(true); // Enable upload button
      } else {
        toast.error("Failed to save mapping.");
      }
    } catch (error) {
      toast.error("Error saving mapping");
      console.error("Error saving mapping:", error);
    }
  };

  const handleFileUpload = async () => {
    try {
      const token = localStorage.getItem("accessToken");
      const adminId = localStorage.getItem("adminId");

      const formData = new FormData();
      formData.append("file", file);

      const response = await axios.post(
        `${path_url}/import/upload/vendor/${adminId}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (response.status === 200) {
        toast.success("Upload successful");
        console.log("file", response);
      } else {
        toast.error("Failed to upload file.");
      }
    } catch (error) {
      toast.error("Error uploading file");
      console.error("Error uploading file:", error);
    }
  };

  return (
    <div>
      <h2>Import Vendors</h2>
      <input
        type="file"
        accept=".csv"
        onChange={handleFileChange}
        style={{ marginLeft: "50px", marginTop: "5px" }}
      />
      {csvData.length > 0 && (
        <div>
          <h3 style={{ marginTop: "5px" }}>Column Mapping</h3>
          {dbColumns.map((dbColumn, index) => (
            <div style={{ margin: "15px 0px 12px 0px" }} key={index}>
              <label>{dbColumn}: </label>
              <select
                onChange={(e) => handleMappingChange(e.target.value, dbColumn)}
              >
                <option value="">Skip</option>
                {csvData.length > 0 &&
                  Object.keys(csvData[0]).map((csvColumn, i) => (
                    <option key={i} value={i}>
                      {csvColumn}
                    </option>
                  ))}
              </select>
            </div>
          ))}
          <button
            onClick={handleSubmitMapping}
            style={{
              marginTop: "10px",
              backgroundColor: "gray",
              color: "white",
              border: "none",
              padding: "10px",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            Save Mapping
          </button>

          {/* Conditionally show Upload button after mapping is saved */}
          {mappingSaved && (
            <button
              onClick={handleFileUpload}
              style={{
                marginTop: "10px",
                marginLeft: "10px",
                backgroundColor: "gray",
                color: "white",
                border: "none",
                padding: "10px",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              Upload File
            </button>
          )}
        </div>
      )}
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </div>
  );
};

export default CsvImport_vendor;
